/* Pet Love Natal — scripts do tema.
   Cada seção é iniciada por init(contexto); no editor da Shopify a seção
   recarregada é iniciada de novo, sem duplicar eventos. */
(function () {
  'use strict';
  var PL = window.PL || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function once(el, key) { var k = 'data-pl-' + key; if (el.hasAttribute(k)) return false; el.setAttribute(k, ''); return true; }
  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    var int = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var fmt = PL.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, int + ',' + v[1]);
  }
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------- Gavetas (menu, carrinho, guia de tamanhos) ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    var bg = d.nextElementSibling; if (bg && bg.classList.contains('drawer-bg')) bg.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var f = $('button, a, input', d); if (f) f.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    var bg = d.nextElementSibling; if (bg && bg.classList.contains('drawer-bg')) bg.classList.remove('is-open');
    document.body.style.overflow = '';
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open')); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer') || document.getElementById(c.getAttribute('data-close'))); return; }
    if (e.target.classList.contains('drawer-bg')) closeDrawer(e.target.previousElementSibling);
    var s = e.target.closest('[data-search-toggle]');
    if (s) { e.preventDefault(); var bar = $('#SearchBar'); if (bar) { bar.hidden = !bar.hidden; if (!bar.hidden) { var i = $('input', bar); if (i) i.focus(); } } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- Carrinho ---------- */
  function renderCart(open) {
    return fetch(PL.routes.root + '?sections=cart-drawer,header').then(function (r) { return r.json(); }).then(function (data) {
      var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      var fresh = $('#CartDrawer', html), cur = $('#CartDrawer');
      if (fresh && cur) {
        var wasOpen = cur.classList.contains('is-open');
        cur.innerHTML = fresh.innerHTML;
        if (wasOpen) cur.classList.add('is-open');
      }
      var hh = new DOMParser().parseFromString(data['header'], 'text/html');
      var fresh2 = $('[data-cart-count]', hh);
      $$('[data-cart-count]').forEach(function (el) { el.innerHTML = fresh2 ? fresh2.innerHTML : ''; });
      if (open) openDrawer('CartDrawer');
    });
  }
  function addToCart(form, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = PL.t.adding; }
    return fetch(PL.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (PL.cartType === 'page') { window.location = PL.routes.cart; return; }
        return renderCart(true);
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || PL.t.unavailable); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-add-form]');
    if (!f) return;
    if (f.querySelector('input[type="file"]')) return; // envio normal quando houver foto
    e.preventDefault();
    addToCart(f, f.querySelector('[data-add-btn]') || (f.id && document.querySelector('[form="' + f.id + '"][data-add-btn]')));
  });
  function changeLine(line, qty) {
    return fetch(PL.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function () {
        if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
        return renderCart(false);
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (b) {
      e.preventDefault();
      var wrap = b.closest('[data-line]'); var line = +wrap.getAttribute('data-line');
      var input = $('input', wrap); var q = +input.value + (+b.getAttribute('data-line-qty'));
      changeLine(line, Math.max(0, q));
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(+rm.getAttribute('data-line-remove'), 0); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line] input');
    if (i) changeLine(+i.closest('[data-line]').getAttribute('data-line'), Math.max(0, +i.value || 0));
    var n = e.target.closest('[data-cart-note]');
    if (n) fetch(PL.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) });
  });

  /* ---------- Produto ---------- */
  function initProduct(ctx) {
    $$('[data-product]', ctx).forEach(function (root) {
      if (!once(root, 'product')) return;
      var dataEl = $('[data-variants]', root);
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = $('form[data-add-form]', root);
      var idInput = form ? $('input[name="id"]', form) : null;
      var btn = $('[data-add-btn]', root);
      var main = $('[data-gallery]', root);

      function current() {
        var opts = $$('[data-opt]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      function goTo(mediaId) {
        if (!main || !mediaId) return;
        var slide = $('[data-media-id="' + mediaId + '"]', main);
        if (slide) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') == mediaId ? 'true' : 'false'); });
      }
      function update() {
        var v = current();
        $$('[data-opt]', root).forEach(function (fs) { var c = $('input:checked', fs); var o = $('[data-opt-value]', fs); if (o && c) o.textContent = c.value; });
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = PL.t.unavailable; } return; }
        if (idInput) idInput.value = v.id;
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? PL.t.add : PL.t.soldOut; }
        var now = $('[data-price-now]', root), was = $('[data-price-was]', root), parc = $('[data-price-parc]', root);
        if (now) now.textContent = money(v.price);
        if (was) { was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; was.hidden = !(v.compare_at_price > v.price); }
        var priceBox = $('[data-price]', root); if (priceBox) priceBox.classList.toggle('price--sale', v.compare_at_price > v.price);
        if (parc) { var n = +parc.getAttribute('data-n') || 1; parc.textContent = parc.getAttribute('data-tpl').replace('__N__', n).replace('__V__', money(Math.floor(v.price / n))); }
        if (v.featured_media) goTo(v.featured_media.id);
        var sb = $('[data-sticky-price]'); if (sb) sb.textContent = money(v.price);
        if (!window.Shopify || !window.Shopify.designMode) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
      }
      root.addEventListener('change', function (e) { if (e.target.closest('[data-opt]')) update(); });
      $$('[data-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { goTo(t.getAttribute('data-thumb')); }); });
      $$('[data-qty]', root).forEach(function (b) {
        b.addEventListener('click', function () { var i = $('input[name="quantity"]', root); if (i) i.value = Math.max(1, (+i.value || 1) + (+b.getAttribute('data-qty'))); });
      });
      var sticky = $('[data-sticky-buy]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); });
        io.observe(btn); root._io = io;
        var sbtn = $('button', sticky); if (sbtn) sbtn.addEventListener('click', function () { if (btn.disabled) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } addToCart(form, btn); });
      }
      var del = $('[data-delivery]', root);
      if (del) {
        var add = function (n) { var d = new Date(), c = 0; while (n > 0 && c < 400) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; c++; } return d; };
        var f = function (d) { return d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' }).replace('.', ''); };
        var a = +del.getAttribute('data-min') || 5, b2 = +del.getAttribute('data-max') || a;
        del.innerHTML = 'Chega entre <strong>' + f(add(a)) + ' e ' + f(add(b2)) + '</strong>';
      }
    });
  }

  /* ---------- Trilhos de produtos ---------- */
  function initRails(ctx) {
    $$('[data-rail]', ctx).forEach(function (wrap) {
      if (!once(wrap, 'rail')) return;
      var track = $('.prail', wrap), prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
      if (!track || !prev || !next) return;
      var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; };
      var sync = function () { prev.disabled = track.scrollLeft < 8; next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true }); sync();
    });
  }


  /* ---------- Banners principais ---------- */
  function initSlides(ctx) {
    $$('[data-slides]', ctx).forEach(function (root) {
      if (!once(root, 'slides')) return;
      var track = $('.slides__track', root), dots = $$('[data-dot]', root), n = dots.length, i = 0, timer;
      if (!track || n < 2) return;
      var go = function (k) {
        i = (k + n) % n;
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        dots.forEach(function (d, j) { d.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      };
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); restart(); }); });
      track.addEventListener('scroll', function () {
        var k = Math.round(track.scrollLeft / track.clientWidth);
        if (k !== i) { i = k; dots.forEach(function (d, j) { d.setAttribute('aria-selected', j === i ? 'true' : 'false'); }); }
      }, { passive: true });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function restart() {
        clearInterval(timer);
        if (root.getAttribute('data-autoplay') !== 'true' || reduce || (window.Shopify && window.Shopify.designMode)) return;
        timer = setInterval(function () { go(i + 1); }, (+root.getAttribute('data-speed') || 6) * 1000);
        root._t = timer;
      }
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restart);
      restart();
    });
  }

  /* ---------- Contagem para o Natal ---------- */
  function initCount(ctx) {
    $$('[data-count]', ctx).forEach(function (el) {
      if (!once(el, 'count')) return;
      var target = new Date(el.getAttribute('data-count')).getTime();
      var set = function (k, v) { var n = $('[data-c="' + k + '"]', el); if (n) n.textContent = String(v).padStart(2, '0'); };
      var tick = function () {
        var d = Math.max(0, target - Date.now());
        set('d', Math.floor(d / 864e5)); set('h', Math.floor(d / 36e5) % 24); set('m', Math.floor(d / 6e4) % 60); set('s', Math.floor(d / 1e3) % 60);
      };
      tick(); el._t = setInterval(tick, 1000);
    });
  }

  /* ---------- Cupom copiável ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]');
    if (!c) return;
    if (navigator.clipboard) navigator.clipboard.writeText(c.getAttribute('data-copy'));
    toast('Cupom copiado!');
  });

  function init(ctx) {
    [initProduct, initRails, initCount, initSlides].forEach(function (fn) { try { fn(ctx || document); } catch (err) { if (window.console) console.warn('[Pet Love]', err); } });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var sl = e.target.closest('[data-slides]'); if (!sl) return;
    var tr = $('.slides__track', sl); var idx = Array.prototype.indexOf.call(tr.children, e.target);
    if (idx > -1) tr.scrollTo({ left: tr.clientWidth * idx, behavior: 'smooth' });
  });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-count], [data-slides]', e.target).forEach(function (el) { clearInterval(el._t); });
    $$('[data-product]', e.target).forEach(function (el) { if (el._io) el._io.disconnect(); });
    document.body.style.overflow = '';
  });
})();
